import { action, makeObservable, observable } from 'mobx';

export default class AuthenticationStore {
  // Authentication
  selectedDatabase = null;
  bearerToken = null;
  refreshBearerToken = null;

  constructor() {
    makeObservable(this, {
      selectedDatabase: observable,
      bearerToken: observable,
      refreshBearerToken: observable,
      setSelectedDatabase: action,
      setBearerToken: action,
      setRefreshBearerToken: action
    })
  }

  setSelectedDatabase(selectedDatabase) {
    this.selectedDatabase = selectedDatabase;
  }

  setBearerToken(bearerToken) {
    this.bearerToken = bearerToken;
  }

  setRefreshBearerToken(refreshBearerToken) {
    this.refreshBearerToken = refreshBearerToken;
  }
}